const rillmentConfig = {
	RG_HOSTNAME: "rillment.games",
	// Feature flag to disable Patreon login/UI (set false for simple SPA)
	PATREON_LOGIN_ENABLED: false,
};
export default rillmentConfig